<template>
    <div class="recomPullNew">
        <img class="title" src="../../../assets/img/pullNew/likeTitle.png" alt="">
        <ul>
            <li
                v-for="item in recommendedActivity"
                :key="item.activityId"
                @click="otherActivity(item.activityId)"
            >
                <img :src="item.pullNewActivityPrizeDataList ? item.pullNewActivityPrizeDataList[0].prizePicture : require('../../../assets/img/pullNew/noprizePicture.png')" alt="">
                <p>免费领取</p>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
  props: {
    recommendedActivity: {
      typeof: Array,
    },
  },
  methods: {
    otherActivity(activityId) {
      this.$router.push({
        path: '/pullnew/home',
        query: {
          activityId,
          pullNewType:this.$root.pullNewType === 2 ? 'yt' : '' 
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.recomPullNew {
    width: 686px;
    margin: 48px auto;
    padding-bottom: 76px;
    background: linear-gradient(180deg, #FDE8E6 0%, #FFDCDB 100%);
    border-radius: 40px;
    .title {
        display: block;
        width: 474px;
        height: 102px;
        margin: 0 auto;
    }
    ul {
        display: flex;
        flex-wrap: wrap;
        padding: 0 22px;
        li {
            position: relative;
            width: 200px;
            height: 200px;
            margin: 48px 20px 0 0 ;
            background: #fff;
            border-radius: 32px;
            img {
                width: 100%;
                height: 100%;
                border-radius: 32px;
            }
            p {
                position: absolute;
                bottom: -28px;
                left: 50%;
                width: 144px;
                height: 56px;
                color: #fff;
                font-size: 24px;
                line-height: 56px;
                text-align: center;
                background: linear-gradient(180deg, #FF5A38 0%, #FF1A3F 100%);
                border-radius: 28px;
                transform: translateX(-50%);
            }
        }
        li:nth-child(3n+3) {
            margin-right: 0;
        }
    }
}
</style>
